module.exports = __webpack_public_path__ + "static/media/NAUT-BNB.a102fa61.svg";